// @ts-nocheck

import * as Types from '../../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type TimesheetSettingsItemFragment = {
  key?: Types.TimesheetSettingsKeyModel | null;
  enabled: boolean;
  revisionAt?: number | null;
  uid: string;
  permissions?:
    | { [name in Types.PermissionName]: { [action in Types.PermissionAction]: Types.VerificationDecisionModel } }
    | null;
  info?: {
    locationRefIds?: Array<string | null> | null;
    globalStartDate?: string | null;
    businessSiteRequired?: boolean | null;
    expenseSubmittals?: {
      supplierGeneralExpensesEnabled: boolean;
      supplierWorkerExpensesEnabled: boolean;
      workerExpensesEnabled: boolean;
    } | null;
  } | null;
};

export type GetTimesheetSettingsListQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.TimesheetSettingsPageModelInput>;
}>;

export type GetTimesheetSettingsListQuery = {
  timesheetSettingsList: { timesheetSettings?: Array<TimesheetSettingsItemFragment | null> | null };
};

export const TimesheetSettingsItemFragmentDoc = gql`
    fragment timesheetSettingsItem on TimesheetSettingsModel {
  key
  enabled
  revisionAt
  uid
  permissions
  info {
    locationRefIds
    globalStartDate
    businessSiteRequired
    expenseSubmittals {
      supplierGeneralExpensesEnabled
      supplierWorkerExpensesEnabled
      workerExpensesEnabled
    }
  }
}
    ` as unknown as DocumentNode<TimesheetSettingsItemFragment, unknown>;
export const GetTimesheetSettingsListDocument = gql`
    query getTimesheetSettingsList($page: TimesheetSettingsPageModelInput) {
  timesheetSettingsList(page: $page) {
    timesheetSettings {
      ...timesheetSettingsItem
    }
  }
}
    ${TimesheetSettingsItemFragmentDoc}` as unknown as DocumentNode<
  GetTimesheetSettingsListQuery,
  GetTimesheetSettingsListQueryVariables
>;
